export default "__VITE_ASSET__d3925a7b__"